module.exports = __webpack_public_path__ + "static/media/Google.45ad3f20.svg";